export const NPI_INFO_LOCKED_ADJUSTMENTS = "Locked adjustments"
export const NPI_INFO_HISTORIC_SALES = "Historic sales"

export enum NpiListColumns {
  EstimatedSeasonality = "estimated seasonality",
  FirstYearSales = "Estimated sales (First 52 weeks)",
  MatchScore = "match score",
  MatchCount = "match count",
  EstimatedFirstYearSales = "estimated first year sales",
  YearOneDemand = "year one demand",
  SimulatedDemand = "simulated demand",
  ManualMatch = "manual match",
  Info = "npi info",
  Update = "npi update",
  WeeksSinceActivation = "weeks since activation",
}
